import auth from "@/helper/middleware/auth";

export default [
  {
    path: "/templates",
    name: "template",
    component: () => import("@/views/template/TemplateView.vue"),
    meta: { middleware: [auth] },
  },
];
